// extracted by mini-css-extract-plugin
module.exports = {"SignupForm__form":"SignupForm_SignupForm__form__7oVi7","SignupForm__close":"SignupForm_SignupForm__close__9456D","SignupForm__note":"SignupForm_SignupForm__note__2O2Kz"};